class FinishedPOIMessage {
	static protocol = {}

	constructor() {}
}

export default FinishedPOIMessage
